import {API_DRIVER} from "../configs/axios";

const AuthService = {
    getToken: () => {
        return API_DRIVER.get("/auth/token", {
            withCredentials: true, headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })
    }
}

export default AuthService
